import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'layout-blank-simplywhite',
  templateUrl: './blank-simplywhite.component.html',
  styleUrls: ['./blank-simplywhite.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlankSimplywhiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
